<template>
    <div :class="{filtering: !showFilter}" class="transparent tag-filter-container">
        <v-btn
            :class="{'red filter-btn-active': isFilterActive, 'orange': !isFilterActive}"
            class="filter-btn"
            @click.native="toggle"
            value="true"
        >
            <span>Filtra</span>
            <v-icon>filter_list</v-icon>
        </v-btn>
        <div class="tag-filter-text" xs12>
            <v-text-field single-line v-if="showFilter" label="Ricerca" v-model="filterText" dark></v-text-field>
        </div>
        <div class="filter-btn-container" v-if="showFilter && targetList !== 'group'">
            <v-btn
                small
                :class="[getTagClass(tag)]"
                @click="handleFilter(tag)"
                :key="i"
                outline
                v-for="(tag, i) in tags"
                class="orange orange--text elevation-2"
                >{{ getDescr(tag) }}</v-btn
            >
        </div>
    </div>
</template>

<script>
/**
 * Crea un tooltip a destra delle voci di menu
 * @module components/common/SideFilter
 */
export default {
    name: 'tag-filter',
    data() {
        return {
            filterText: '',
            showFilter: false,
        };
    },
    props: ['target', 'targetList'],
    watch: {
        filterText(v) {
            this.$emit('text', v);
        },
        targetList(value) {
            this.targetList = value;
        },
    },
    mounted() {
        this.$emit('resize');
    },
    methods: {
        getDescr(item) {
            return utils.getMainDesc(item);
        },
        handleFilter(tag) {
            this.$store.dispatch('HANDLELIBFILTER', {
                tag,
                target: this.target,
            });
        },
        getTagClass(tag) {
            if (this.filters.specific != null && this.filters.specific._id == tag._id) {
                return 'tag-selected';
            } else if (tag.tipo == 'GOBACK') {
                return 'goback';
            }
            return null;
        },
        open() {
            this.showFilter = true;
        },
        toggle() {
            this.$emit('resize');
            this.showFilter = !this.showFilter;
        },
    },
    computed: {
        tags() {
            this.$emit('resize');
            return this.$store.getters.filteredTags(this.target);
        },
        filters() {
            return this.$store.getters.libGroupFilters(this.target);
        },
        isFilterActive() {
            return this.filters.specific != null || this.filters.selected != null;
        },
    },
};
</script>

<style lang="stylus">
.tag-filter-container {
    position: relative;
    background: #f57c00;
    box-shadow: 0 3px 14px 2px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    height: auto;
    justify-content: center;
    width: 100%;
    z-index: 4;

    .tag-filter-text {
        padding-bottom: 10px;
        padding-right: 4px;
        padding-left: 4px;

        .input-group {
            label {
                top: 9px;
            }

            padding-top: 9px;
            padding-bottom: 0;
        }

        .input-group__details {
            min-height: 0;
        }
    }

    &.filtering {
        height: 10px;
        min-height: 0;

        .filter-btn {
            right: 20px;
        }
    }

    .filter-btn {
        z-index: 4;
        position: absolute;
        margin: auto;
        top: -18px;
        right: 5px;
        min-width: 36px;
        border-radius: 36px;
        width: 36px;

        .btn__content span {
            display: none;
        }
    }

    .filter-btn-container {
        flex-wrap: wrap;
        display: flex;
        align-items: center;

        .chip {
            cursor: pointer;

            &:hover {
                opacity: 0.5;
            }
        }
    }
}

.filter-btn-active {
    -webkit-animation: pulse 1.5s infinite;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TagFilter.vue